import axios from 'axios';
import { toast } from 'react-toastify';
import { store } from '../redux/store'
import { URLS } from './Urls';

const API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_URL : process.env.REACT_APP_LOCAL_URL;

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instanceFile = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

const publicRoutes = [URLS.GetUserLogin];

instance.interceptors.request.use(
  (config) => {
    const state = store.getState(); // Get Redux state
    const token = state.auth?.token; // Get the access token from Redux state

    // Attach the token only if the route is not public
    if (token && !publicRoutes.includes(config.url)) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired token (401 Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry && !publicRoutes.includes(originalRequest.url)) {
      originalRequest._retry = true; // Mark the request as retried

      const state = store.getState(); // Get Redux state
      const refreshToken = state.auth?.refreshToken; // Get the refresh token from Redux state

      if (refreshToken) {
        try {
          // Request a new access token using the refresh token
          const response = await axios.post('/token/refresh/', {
            refresh: refreshToken,
          });

          const newAccessToken = response.data.access;

          // Update the access token in Redux store
          store.dispatch({
            type: 'updateToken',
            payload: { token: newAccessToken },
          });

          // Update the Authorization header with the new access token
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

          // Retry the original request with the new access token
          return instance(originalRequest);
        } catch (refreshError) {
          // Handle refresh token failure (e.g., logout the user)
          toast.error('Session expired. Please log in again.');
          store.dispatch({ type: 'logout' }); // Dispatch a logout action
          window.location.href = '/auth/login'; // Redirect to login page
          return Promise.reject(refreshError);
        }
      } else {
        // No refresh token available
        toast.error('Session expired. Please log in again.');
        store.dispatch({ type: 'logout' }); // Dispatch a logout action
        window.location.href = '/auth/login'; // Redirect to login page
        return Promise.reject(error);
      }
    }
     return Promise.reject(error);
  }
);

instanceFile.interceptors.request.use(
  (config) => {
    const state = store.getState(); // Get Redux state
    const token = state.auth?.token; // Get the access token from Redux state

    // Attach the token only if the route is not public
    if (token && !publicRoutes.includes(config.url)) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instanceFile.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired token (401 Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry && !publicRoutes.includes(originalRequest.url)) {
      originalRequest._retry = true; // Mark the request as retried

      const state = store.getState(); // Get Redux state
      const refreshToken = state.auth?.refreshToken; // Get the refresh token from Redux state

      if (refreshToken) {
        try {
          // Request a new access token using the refresh token
          const response = await axios.post('/token/refresh/', {
            refresh: refreshToken,
          });

          const newAccessToken = response.data.access;

          // Update the access token in Redux store
          store.dispatch({
            type: 'updateToken',
            payload: { token: newAccessToken },
          });

          // Update the Authorization header with the new access token
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

          // Retry the original request with the new access token
          return instance(originalRequest);
        } catch (refreshError) {
          // Handle refresh token failure (e.g., logout the user)
          toast.error('Session expired. Please log in again.');
          store.dispatch({ type: 'logout' }); // Dispatch a logout action
          window.location.href = '/auth/login'; // Redirect to login page
          return Promise.reject(refreshError);
        }
      } else {
        // No refresh token available
        toast.error('Session expired. Please log in again.');
        store.dispatch({ type: 'logout' }); // Dispatch a logout action
        window.location.href = '/auth/login'; // Redirect to login page
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
export { instanceFile, API_URL };